import React from 'react'

import TwoColumnsCard from '../../../react4xp/components/TwoColumnsCard'

function TwoColumnCardPart({ title, intro, text, color }) {
    return (
        <TwoColumnsCard
            blockColor={color}
            title={title}
            text={intro}
            content={text}
        />
    )
}

export default (props) => <TwoColumnCardPart {...props} />
